import { Injectable } from '@angular/core';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';

@Injectable()
export class ReportValidator {

    formValidation: any;

    /**
     * Constructor
     */
    constructor() {
        this.setDefault();
    }    

    /**
     * Set default values
     */
    setDefault() {
        this.formValidation = {        
            parameterLength: false,
            checkboxParamError: false,
        }
    }

    validateReportForm(paramsToValidate, expectedLength, checkboxParameters, modalData) {
        modalData[0] = "Valideringsfel";
        modalData[1] = "Vi kunde inte hitta vad som gick fel.";
        if(this.validateParamLength(paramsToValidate.length, expectedLength, modalData)
            && this.validateNotNullCheckboxParameters(checkboxParameters, modalData)) {
            return true;
        } else {
            return false;
        }
    }

    validateParamLength(paramLengthToValidate, expectedLength,  modalData = ["", ""]) {
        if (paramLengthToValidate != expectedLength) {
            this.formValidation.parameterLength = true;
            modalData[0] = "Valideringsfel: Valda parametrar";
            modalData[1] = "Kontrollera att samtliga parametrar är valda.";
        } else {
            this.formValidation.parameterLength = false;
        }
        return !this.formValidation.parameterLength;
    }

    validateNotNullCheckboxParameters(checkboxParameters, modalData = ["", ""]) {
        if (checkboxParameters === null || checkboxParameters.length === 0) {
            this.formValidation.checkboxParamError = true;
            modalData[0] = "Valideringsfel: Valda kollumner";
            modalData[1] = "Kontrollera att någon kollumn är vald.";
        } else {
            this.formValidation.checkboxParamError = false;
        }
        return !this.formValidation.checkboxParamError;
    }
}